import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { RequireAuth } from '@/components/RequireAuth'
import { Layout } from '@/components/Layout'

import Login from '@/pages/Login'
import Home from '@/pages/Home'
import Projects from '@/pages/Projects'
import ProjectDetail from '@/pages/ProjectDetail'
import MyDashboard from '@/pages/MyDashboard'
import Ideas from '@/pages/Ideas'
import Approvals from '@/pages/Approvals'
import CalendarPlan from '@/pages/CalendarPlan'
import ContentPlan from '@/pages/ContentPlan'
import Reports from '@/pages/Reports'
import Timeline from '@/pages/Timeline'
import HistoryLog from '@/pages/HistoryLog'
import Users from '@/pages/Users'
import Onboarding from '@/pages/Onboarding'
import Dev from '@/pages/Dev'
import Ticketing from '@/pages/Ticketing'
import Notifications from '@/pages/Notifications'

// Bungkus halaman app dengan gerbang auth + shell (sidebar/ml-14/gates).
function App({ children }: { children: React.ReactNode }) {
  return (
    <RequireAuth>
      <Layout>{children}</Layout>
    </RequireAuth>
  )
}

// Peta rute pusat — 14 rute. Login publik (tanpa Layout); sisanya di dalam
// RequireAuth + Layout. Onboarding tetap di dalam auth (RequireAuth
// meloloskannya walau user belum punya departemen).
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<App><Home /></App>} />
      <Route path="/projects" element={<App><Projects /></App>} />
      <Route path="/projects/:id" element={<App><ProjectDetail /></App>} />
      <Route path="/my-dashboard" element={<App><MyDashboard /></App>} />
      <Route path="/ideas" element={<App><Ideas /></App>} />
      <Route path="/ticketing" element={<App><Ticketing /></App>} />
      <Route path="/notifications" element={<App><Notifications /></App>} />
      <Route path="/approvals" element={<App><Approvals /></App>} />
      <Route path="/calendar-plan" element={<App><CalendarPlan /></App>} />
      <Route path="/content-plan" element={<App><ContentPlan /></App>} />
      <Route path="/reports" element={<App><Reports /></App>} />
      <Route path="/timeline" element={<App><Timeline /></App>} />
      <Route path="/history-log" element={<App><HistoryLog /></App>} />
      <Route path="/users" element={<App><Users /></App>} />
      <Route path="/onboarding" element={<App><Onboarding /></App>} />
      <Route path="/dev" element={<App><Dev /></App>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
